// src/components/ProtectedRoute.jsx
import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

export default function ProtectedRoute({ children, adminOnly = true }) {
  const { currentUser } = useAuth();
  const location = useLocation();

  if (!currentUser) {
    // Redirigir al login si no está autenticado
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  if (adminOnly) {
    // Aquí puedes agregar lógica para verificar roles si necesitas
    // Por ahora, cualquier usuario autenticado puede acceder
    return children;
  }

  return children;
}